import React, { Component } from 'react';
import {HashRouter as Router,Route,Switch} from 'react-router-dom';
import Auth from '../auth/auth';
import ExpoPreviewer from '../expo-previewer/expo-previewer';
import Dashboard from '../dashboard/dashboard';
import SeriesList from '../series-list/series-list';
import ExpoEditor from '../expo-editor/expo-editor';
import Booth from '../booth/booth';
import NavigationBar from '../navigation-bar/navigation-bar';
import Overlay from '../overlay/overlay';

/** @class App
  * The main component for vexpo-editor-react
  */
export default class App extends Component {
  /** @method render
    * Renders the application.
    */
  render() {
    switch(window.location.pathname) {
      case '/preview/':
        return <ExpoPreviewer />
      default:
        return (
          <Router>
            <Auth>
              <Switch>
                <Route path="/preview/:expoID" render={({match}) => (
                  <ExpoPreviewer />
                )} />
                <Route path="/expos/:expoID" render={({match}) => (
                  <div className="editor-app">
                    <NavigationBar expoID={match.params.expoID}/>
                    <ExpoEditor />
                  </div>
                )}/>
                <Route path="/" render={()=>(
                  <div>
                    <NavigationBar/>
                    <SeriesList />
                  </div>
                )}/>
              </Switch>
              <Overlay/>
            </Auth>
          </Router>
        );
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/app/app.js